module.exports = {
      id: "rustore-dark-usage",
      viewBox: "0 0 135 41",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#rustore-dark-usage",
      toString: function () {
        return this.url;
      }
    }